<template>
    <div class="list_config chartConfig_viewDP">
        <div class="chartDivConfig selViewConfig">
            <span class="span_til span_tilMax">表头背景</span>
            <el-select v-model="config.titleStyle.background.type" placeholder="请选择标体背景"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in backgroundTitleSelect"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig colViewConfig" v-if="config.titleStyle.background.type === 'color'">
            <span class="span_til span_tilMax">表头颜色</span>
            <el-color-picker v-model="config.titleStyle.background.color"  show-alpha @change="setColorGroup"></el-color-picker>
        </div>
        <div class="chartDivConfig selViewConfig" v-if="config.titleStyle.background.type === 'picture'">
            <span class="span_til span_tilMax">表头图片</span>
            <el-select v-model="config.titleStyle.background.picture" placeholder="请选择图片"
                       :popper-append-to-body="false" class="el-popper-back" @change="getRender">
                <el-option :label="'图片背景'+(index+1)" :value="item.img" v-for="(item,index) in comPicture">
                    <img :src="`${configImgUrl()}${item.img}`" alt="">
                    <span>{{'图片背景'+(index+1)}}</span>
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig" v-if="config.titleStyle.background.type === 'border'">
            <span class="span_til span_tilMax">表头边框</span>
            <el-select v-model="config.titleStyle.background.border" placeholder="请选择边框"
                       :popper-append-to-body="false" class="el-popper-back" @change="getRender">
                <el-option :label="'边框'+(index+1)" :value="item.img" v-for="(item,index) in comBorder">
                    <img :src="`${configImgUrl()}${item.img}`" alt="">
                    <span>{{'边框'+(index+1)}}</span>
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig">
            <span class="span_til span_tilMax">表体背景</span>
            <el-select v-model="config.bodyStyle.background.type" placeholder="请选择标体背景"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in backgroundSelect"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig colViewConfig" v-if="config.bodyStyle.background.type === 'color'">
            <span class="span_til span_tilMax">表体颜色组</span>
            <el-color-picker  v-model="colorGroup[index]" v-for="(item,index) in colorGroup" show-alpha @change="setColorGroup"></el-color-picker>
            <FSvg title="圆加" :color="'#fff'" IconSize="22" @click.native="getAddColor()"></FSvg>
            <FSvg title="圆叉删除" :color="'#fff'" IconSize="22" @click.native="getclearColorGroup()"></FSvg>
        </div>
        <div class="chartDivConfig selViewConfig" v-if="config.bodyStyle.background.type === 'picture'">
            <span class="span_til span_tilMax">表体图片</span>
            <el-select v-model="config.bodyStyle.background.picture" placeholder="请选择图片"
                       :popper-append-to-body="false" class="el-popper-back" @change="getRender">
                <el-option :label="'图片背景'+(index+1)" :value="item.img" v-for="(item,index) in comPicture">
                    <img :src="`${configImgUrl()}${item.img}`" alt="">
                    <span>{{'图片背景'+(index+1)}}</span>
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig selViewConfig" v-if="config.bodyStyle.background.type === 'border'">
            <span class="span_til span_tilMax">表体边框</span>
            <el-select v-model="config.bodyStyle.background.border" placeholder="请选择边框"
                       :popper-append-to-body="false" class="el-popper-back" @change="getRender">
                <el-option :label="'边框'+(index+1)" :value="item.img" v-for="(item,index) in comBorder">
                    <img :src="`${configImgUrl()}${item.img}`" alt="">
                    <span>{{'边框'+(index+1)}}</span>
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    import {pictureList,borderList} from "../../../../createScreen/script/comChart";

    export default {
        name: 'btn_config_config',
        components: {

        },
        data() {
            return {
                backgroundSelect:[
                    {name:'颜色组背景',value:'color'},
                    {name:'边框背景',value:'border'},
                    {name:'图片背景',value:'picture'}
                ],
                backgroundTitleSelect:[
                    {name:'纯色背景',value:'color'},
                    {name:'边框背景',value:'border'},
                    {name:'图片背景',value:'picture'}
                ],
                colorGroup:[],
                comPicture:[],
                comBorder:[],
            }
        },
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            }
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
            setColorGroup(){
                this.config.bodyStyle.background.colorGroup = this.colorGroup;
                this.getRender();
            },
            getAddColor(){
                if(this.colorGroup.length === 0){
                    let a =[];
                    a.push('rgba(255, 255, 255, .5)')
                    this.colorGroup = a;
                }else {
                    if(this.colorGroup.length <5){
                        this.colorGroup.push('rgba(255, 255, 255, .5)')
                    }else {
                        this.$message({
                            type:'warning',
                            message:'颜色组最多五种颜色！'
                        })
                    }
                }
            },
            getclearColorGroup(){
                this.config.bodyStyle.background.colorGroup = [];
                this.colorGroup = [];
                this.getRender();
            }
        },
        mounted() {
            this.colorGroup = this.config.bodyStyle.background.colorGroup;
            this.comPicture = pictureList;
            this.comBorder = borderList;
        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .list_config {
        .chartDivConfig {
            .span_til {
                max-width: 90px !important;
                width: 32% !important;
            }
            /*.span_tilMax {*/
            /*    max-width: 90px !important;*/
            /*    width: 32% !important;*/
            /*}*/
            .el-popper-back {
                .el-popper {
                    width: 220px;
                    .el-scrollbar{
                        .el-scrollbar__wrap{
                            padding: 8px;
                            height: 100%;
                            >ul{
                                >li{
                                    height: 60px;
                                    width: calc(50% - 2px);
                                    line-height: 60px;
                                    padding: 2px;
                                    margin: 0;
                                    display: inline-block;
                                    vertical-align: top;
                                    position: relative;
                                    text-align: center;
                                    >span{
                                        position: absolute;
                                        bottom: 5%;
                                        left: 5%;
                                        line-height: 20px;
                                    }
                                    >img{
                                        height: 55px;
                                    }
                                }
                            }
                        }
                    }
                }
            }

        }
    }
</style>
